<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-20 11:22:43
 * @LastEditors: 邹腾 teng.zou@ruthus.com
 * @LastEditTime: 2023-08-16 10:10:02
-->

<template>
  <div
    class="boxMian"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.backgroundImg}')` }">
      <div class="bg">
        <div class="podium">
          <div class="second item">
            <div class="avatarUrl">
              <template v-if="ranking.length >= 2">
                <img class="userImg" :src="ranking[1].headImgUrl || 'https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/avatar.png'" />
                <img class="rank" src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank2.png" />
              </template>
            </div>
            <div class="base">
              <div class="noodles"></div>
              <div ref="second" class="baseBox">
                <template v-if="ranking.length >= 2">
                  <div class="userName">{{ ranking[1].nickname }}</div>
                  <div class="count">{{ ranking[1].count }}</div>
                  <div class="tip">助力值</div>
                </template>
              </div>
              <!-- :style="{
                backgroundImage: `linear-gradient(180deg, #B70110 0%, #B7011000 100%);`,
              }" -->
            </div>
          </div>
          <div class="first item">
            <div class="avatarUrl">
              <template v-if="ranking.length >= 1">
                <img class="userImg" :src="ranking[0].headImgUrl || 'https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/avatar.png'" />
                <img class="rank" src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank1.png" />
              </template>
            </div>
            <div class="base">
              <div class="noodles"></div>
              <div ref="first" class="baseBox">
                <template v-if="ranking.length >= 1">
                  <div class="userName">{{ ranking[0].nickname }}</div>
                  <div class="count">{{ ranking[0].count }}</div>
                  <div class="tip">助力值</div>
                </template>
              </div>
              <!-- :style="{
                backgroundImage: `linear-gradient(180deg, #B70110 0%, #B7011000 100%);`,
              }" -->
            </div>
          </div>
          <div class="third item">
            <div class="avatarUrl">
              <template v-if="ranking.length >= 3">
                <img class="userImg" :src="ranking[2].headImgUrl || 'https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/avatar.png'" />
                <img class="rank" src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank3.png" />
              </template>
            </div>
            <div class="base">
              <div class="noodles"></div>
              <div ref="third" class="baseBox">
                <template v-if="ranking.length >= 3">
                  <div class="userName">{{ ranking[2].nickname }}</div>
                  <div class="count">{{ ranking[2].count }}</div>
                  <div class="tip">助力值</div>
                </template>
              </div>
              <!-- :style="{
                backgroundImage: `linear-gradient(180deg, #B70110 0%, #B7011000 100%);`,
              }" -->
            </div>
          </div>
        </div>
        <div :class="['model']" :style="model">
          <div
            class="modelTitle"
            :style="{
              backgroundColor: configInfo.mainColour,
              color: configInfo.buttonTextColour,
            }"
          >
            · 排行榜 ·
          </div>

          <div class="modelBg">
            <div class="list">
              <div class="item self" :style="{ backgroundColor: $util.rgbToRgba( configInfo.mainColour,0.1),color: configInfo.backgroundColour  }">
                <div class="rank">{{ this.ranking.length>100&&selfRank==-1?'100+':((selfRank+1)||'-') }}</div>
                <img class="userImg" :src="$userInfo.avatarUrl || 'https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/avatar.png'" />
                <div class="userName" :style="{color: configInfo.backgroundColour }">{{ $userInfo.nickname || "微信用户" }}</div>
                <div class="num">{{ assistanceNumber }}</div>
                <div class="icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.8941 6.40786H10.4959C12.2004 0.309582 9.3215 0 9.3215 0C8.10146 0 8.35511 0.933661 8.26126 1.09091C8.26126 4.07125 4.99176 6.40786 4.99176 6.40786V14.8649C4.99176 15.7002 6.16614 16 6.62777 16H13.2353C13.8567 16 14.364 14.4201 14.364 14.4201C16 9.0344 16 7.43243 16 7.43243C16 6.31941 14.8941 6.40786 14.8941 6.40786ZM3.18833 6.41032H0.552949C0.0101459 6.41032 0 6.92875 0 6.92875L0.542803 15.457C0.542803 16 1.10336 16 1.10336 16H3.38364C3.85796 16 3.85542 15.6413 3.85542 15.6413V7.05897C3.85796 6.40295 3.18833 6.41032 3.18833 6.41032Z"
                      :fill="configInfo.backgroundColour"
                    />
                  </svg>
                  <span >助力值</span>
                </div>
              </div>
              <div class="item" v-for="(item, index) in ranking" :key="index" v-if="index >= 3">
                <div class="rank">{{ index + 1 }}</div>
                <img class="userImg" :src="item.headImgUrl || 'https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/avatar.png'" />
                <div class="userName">{{ item.nickname || "微信用户" }}</div>
                <div class="num">{{ item.count }}</div>
                <div class="icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.8941 6.40786H10.4959C12.2004 0.309582 9.3215 0 9.3215 0C8.10146 0 8.35511 0.933661 8.26126 1.09091C8.26126 4.07125 4.99176 6.40786 4.99176 6.40786V14.8649C4.99176 15.7002 6.16614 16 6.62777 16H13.2353C13.8567 16 14.364 14.4201 14.364 14.4201C16 9.0344 16 7.43243 16 7.43243C16 6.31941 14.8941 6.40786 14.8941 6.40786ZM3.18833 6.41032H0.552949C0.0101459 6.41032 0 6.92875 0 6.92875L0.542803 15.457C0.542803 16 1.10336 16 1.10336 16H3.38364C3.85796 16 3.85542 15.6413 3.85542 15.6413V7.05897C3.85796 6.40295 3.18833 6.41032 3.18833 6.41032Z"
                      :fill="configInfo.backgroundColour"
                    />
                  </svg>
                  <span  :style="{ color: configInfo.backgroundColour }">助力值</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BaseBottom :configInfo="configInfo" />
        <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue/dist/vue.js";
// import Grid from "./components/grid";
// import Pointer from "./components/pointer";
// import ButtonList from "./components/buttonList";
// import { getUserInfo2 } from "@/http/rushi-wx";
import util from "@/utils/common";

// const statusTipMap = {
//   0: "该活动无效",
//   1: "该活动待发布",
//   2: "该活动未上线",
//   4: "该活动已下线",
//   5: "该活动已下线",
// };

export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo: {}, //配置信息
      ranking: [],
      back: "#fff",
      selfRank:-1,
      assistanceNumber:0,
    };
  },
  watch: {
    "configInfo.backgroundColour": {
      handler(val) {
        this.$nextTick(() => {
          let name = ["first", "second", "third"];
          name.map((item) => {
            this.$refs[item].style = `background: linear-gradient(180deg, ${val} 0%, ${val}00 100%);`;
          });
        });
      },
      deep: true,
    },
  },
  computed: {
    model() {
      return {
        borderColor: this.configInfo.mainColour,
      };
    },
  },
  mounted() {
    this.configInfo = this.$configInfo;
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
    this.initRanking();
     this.getAssistanceNumber();
  },
  created() {},
  methods: {
    // 页面配置
    async initRanking() {
      let param = this.$apizt.action.getAssistanceRank;
      const { data, result } = await this.$httpzt.requestRestFul(param, {
        actCode: this.$actCode,
        size: 100,
      });
      if (result) {
        console.log(data);
        this.ranking = data;
        this.selfRank = data.findIndex(item => item.openId === this.$openid);
      }
    },
    // 获取当前用户点亮值
    async getAssistanceNumber() {
      let url = this.$apizt.action.getAssistanceNumber;
      let { data, result } = await this.$httpzt.requestRestFul(url, {}, "get");
      if (result) {
        this.assistanceNumber = data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 80px;

    .bg {
      position: absolute;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .podium {
      display: flex;
      margin: 30px auto 0;
      justify-content: center;

      .item {
        width: 129px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .avatarUrl {
          position: relative;
          width: 66px;
          height: 66px;
          z-index: 1;

          .userImg {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            border: 2px solid #fff;
            box-sizing: border-box;
          }

          .rank {
            position: absolute;
            top: 42px;
            left: 44px;
            width: 24px;
          }
        }

        .base {
          width: 100%;
          margin-top: -15px;

          .noodles {
            width: 100%;
            border-bottom: 20px solid rgba(255, 255, 255, 0.5);
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
          }

          .baseBox {
            width: 100%;
            height: 110px;
            padding: 0 10px;

            .userName {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              text-align: center;
              color: #FFFFFF;
              padding-top: 6px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .count {
              font-family: DIN Alternate;
              font-weight:normal;
              font-size: 32px;
              line-height: 24px;
              text-align: center;
              color: #FFFFFF;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .tip {
              font-size: 10px;
              line-height: 10px;
              text-align: center;
              color: #FFFFFF;
              margin-top: 6px;
            }
          }
        }
      }

      .second {
        width: 105px;
        margin-top: 50px;

        .avatarUrl {
          width: 48px;
          height: 48px;

          .rank {
            top: 25px;
            left: 28px;
          }
        }

        .base .baseBox .count {
          font-size: 24px;
        }

        .noodles {
          border-right: none !important;
        }
      }

      .third {
        width: 105px;
        margin-top: 50px;

        .avatarUrl {
          width: 48px;
          height: 48px;

          .rank {
            top: 25px;
            left: 28px;
          }
        }

        .base .baseBox .count {
          font-size: 24px;
        }

        .noodles {
          border-left: none !important;
        }
      }
    }

    .kv {
      width: 343px;
      margin: 40px auto 0;
    }

    .model {
      width: 351px;
      margin: 0px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 12px;
      height: calc(100vh - 284px);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border: 5px solid;
      box-sizing: border-box;
      position: relative;
      top:-1px;
      &.purchase{
        box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
        border: 10px solid rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
        .modelTitle {
          margin-top:-10px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
          border-radius: 0px 0px 12px 12px;
        }
      }
      .modelTitle {
        position: absolute;
        margin-top: -20px;
        font-weight: bold;
        color: white;
        padding: 0 20px;
        line-height: 40px;
        height: 40px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        z-index: 1;
        font-size: 20px;
      }

      .modelBg {
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 7px;
        padding: 30px 10px 10px;

        .list {
          height: 100%;
          overflow-y: auto;

          .item {
            width: 100%;
            display: flex;
            height: 64px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);
            padding:0 10px;
            border-radius: 4px;

            .rank {
              width: 24px;
              height: 24px;
              font-weight: bold;
              font-size: 18px;
              line-height: 24px;
              text-align: center;
              color: #617086;
            }

            .userImg {
              width: 32px;
              height: 32px;
              border-radius: 16px;
            }

            .userName {
              flex: 1;
              padding: 0 16px;
              font-weight: normal;
              font-size: 16px;
              line-height: 24px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .num {
              font-weight: bold;
              font-size: 24px;
              line-height: 24px;
              text-align: center;
              color: #262626;
            }

            .icon {
              width: 40px;
              display: flex;
              flex-direction: column;
              align-items: center;
              font-weight: 500;
              font-size: 9px;
              line-height: 10px;
              margin-left:10px;

              span {
                margin-top: 5px;
              }
            }
          }

          .item:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
